import { $, $$ } from '@3pc/dom';
import { ClickRedirect } from '@3pc/click-redirect';

const imageItems = $$('.news-image');

if (imageItems.length) {
  imageItems.forEach(imageItem => {
    // Get references to the source and target elements
    const sourceElement = $('.news-image__picture', imageItem);
    const targetElement = $('.news-image__link', imageItem);

    if (!sourceElement || !targetElement) {
      return;
    }

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    // Create a ClickRedirect instance
    const clickRedirect = new ClickRedirect(
      sourceElement,
      targetElement,
      config
    );

    // Activate the ClickRedirect (add event listeners)
    clickRedirect.activate();
  });
}
